<template>
    <div class="page">
        <p v-if="$config.unauthorizedMessage" v-html="$config.unauthorizedMessage"></p>
        <p v-else>Unfortunately, we could not detect session data for your account.</p>
    </div>
</template>

<script>

export default {
    data () {
        return {}
    }
}

</script>

<style lang="postcss" scoped>
@import 'theme';

p {
    font-size: 16px;
    text-align: center;
}

.page {
    margin: 0 auto;
    max-width: 100%;
    padding: 100px var(--site-padding);
    width: var(--site-container-width);
}
</style>
